import { useFieldTheme } from 'framework/field/hooks/useFieldTheme';
import { useOptionsTheme } from 'framework/Options/hooks/useOptionsTheme';

import { EMPTY_FUNCTION } from '../../constants';
import { useDropdownContext } from '../dropdown/context/DropdownContext';

import { OptionContext } from './context/OptionContext';
import { Option as OptionComponent } from './fields/Option';
import { OptionBreak } from './fields/OptionBreak';
import { OptionBreakProps, OptionIndicatorProps } from './types';

import cn from './Option.module.scss';

export const Option = () => {
  const { options, option_key } = useDropdownContext();
  return (
    <>
      {options.map((option, index) => (
        <OptionContext.Provider
          key={`option-${option[option_key]}`}
          value={{ index, label: option[option_key], option }}
        >
          <OptionComponent />
        </OptionContext.Provider>
      ))}
      {options.length === 0 && <OptionComponent />}
    </>
  );
};

export const OptionMenu = ({ label, icon, onSelect = EMPTY_FUNCTION }: OptionBreakProps) => {
  const { options, option_key } = useDropdownContext();
  return (
    <>
      {options.map((option, index) => (
        <OptionContext.Provider
          key={`option-${option[option_key]}`}
          value={{ index, label: option[option_key], option }}
        >
          <OptionComponent />
        </OptionContext.Provider>
      ))}
      <OptionBreak label={label} icon={icon} onSelect={onSelect} />
    </>
  );
};

export const OptionIndicator = ({ indicator, last = false }: OptionIndicatorProps) => {
  const { options, option_key, theme } = useDropdownContext();
  const { border } = useFieldTheme(theme?.field);
  const options_theme = useOptionsTheme(theme?.options);

  return (
    <>
      <p
        className={cn.option}
        style={{ height: options_theme.settings.option_height, fontWeight: 500 }}
      >
        {indicator.indicator_category_name}
      </p>
      {options
        .filter((option) => option.indicator_category_id === indicator.indicator_category_id)
        .map((option, index) => (
          <OptionContext.Provider
            key={`option-${option[option_key]}`}
            value={{ index, label: option[option_key], option }}
          >
            <OptionComponent margin="0px 0px 0px 8px" />
          </OptionContext.Provider>
        ))}
      {!last && <div className={cn.break} style={{ borderTop: border.normal }} />}
    </>
  );
};
